import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, H2, H3, H5, H6, Small, Tiny } from "@/components/standard/BFText"
import { View } from "react-native"
import { PrimaryDarkButton } from "@/components/buttons/CommonButtons"
import { openNewLoanQuote } from "@/screens/loans/utils/openNewLoanQuote"
import TimeSmall from "@/assets/icons/time-small.svg"
import CheckSmall from "@/assets/icons/check-small.svg"
import BindingSmall from "@/assets/icons/binding-small.svg"
import TealCheck from "@/assets/icons/teal-check.svg"
import { Fragment } from "react"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { useSafeAreaInsets } from "react-native-safe-area-context"

interface TimelineData {
  title: string
  timeLeft?: string
  completed?: boolean
}

const TIMELINE_HAS_QUAL: TimelineData[] = [
  {
    title: "Check Qualification",
    timeLeft: "1 min",
  },
  {
    title: "Update Property Info",
    timeLeft: "1 min",
  },
  {
    title: "Select Loan Product",
    timeLeft: "1 min",
  },
  {
    title: "Review Estimates & Submit*",
    timeLeft: "1 min",
  },
]

const LoanTimeline = ({
  data,
  index,
}: {
  data: TimelineData
  index: number
}) => {
  return (
    <Vertical>
      <Horizontal className={"items-center gap-1"}>
        <H6 color={"teal"}>STEP {index + 1}</H6>
        {data.completed && <TealCheck />}
      </Horizontal>
      <Horizontal className={"justify-between w-full"}>
        <H5 color={"white"}>{data.title}</H5>
        {data.completed ? (
          <Small className={"color-calm-blue"}>Completed</Small>
        ) : (
          <Small color={"teal"}>{data.timeLeft}</Small>
        )}
      </Horizontal>
    </Vertical>
  )
}

export const LoanLandingScreen = ({
  backButton = true,
}: {
  backButton?: boolean
}) => {
  const insets = useSafeAreaInsets()

  const data = TIMELINE_HAS_QUAL

  return (
    <BFScreen dark={true} gradientBackground={true} noBackButton={!backButton}>
      <Vertical className={"justify-between flex-1 p-8"}>
        <Vertical className={"flex-1 gap-0"}>
          <H2
            style={{ paddingTop: insets.top + 20, paddingBottom: 20 }}
            color={"white"}
          >
            Loans
          </H2>
          <Vertical className={"pt-8 gap-5"}>
            <H3 color={"teal"}>Let’s get you funded</H3>
            <Body color={"white"}>
              Answer a few short questions so we can create the best quote for
              your next deal.
            </Body>

            <Vertical className={"bg-midnight-blue p-5 gap-3 rounded-lg"}>
              {data.map((item, index) => (
                <Fragment key={index}>
                  <LoanTimeline index={index} data={item} />
                  {index !== data.length - 1 && (
                    <View className={`border-b border-calm-blue`} />
                  )}
                </Fragment>
              ))}
            </Vertical>

            <Tiny color={"white"} className={"px-3"}>
              *Our loan experts will review terms with you before finalization
            </Tiny>
          </Vertical>
        </Vertical>
        <Vertical className={"gap-3 items-center shrink-0"}>
          <PrimaryDarkButton
            testID={"get-started-button"}
            title={"Get Started"}
            onPress={openNewLoanQuote}
          />
          <Horizontal className={"gap-1 items-center"}>
            <TimeSmall />
            <Small color={"white"}>4 min | </Small>
            <CheckSmall />
            <Small color={"white"}>No credit impact | </Small>
            <BindingSmall />
            <Small color={"white"}>Non-binding</Small>
          </Horizontal>
        </Vertical>
      </Vertical>
    </BFScreen>
  )
}
